import React, { useState, useEffect } from 'react';

const CircleProgressBar = ({ percentage, strokeWidth, sqSize, color }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= percentage) {
          clearInterval(timer);
          return prevProgress;
        } else {
          return prevProgress + 1;
        }
      });
    }, 10);

    return () => {
      clearInterval(timer);
    };
  }, [percentage]);

  const calculatePath = (radius) => {
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (progress / 100) * circumference;
    return { circumference, offset };
  };

  return (
    <svg width={sqSize} height={sqSize} viewBox={`0 0 ${sqSize} ${sqSize}`}>
      <g transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}>
      <circle
        className="circle-background"
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={(sqSize - strokeWidth) / 2}
        fill="none"
        stroke="#e6e6e6"
        strokeWidth={strokeWidth}
      />
      <circle
        className="circle-progress"
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={(sqSize - strokeWidth) / 2}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={`${calculatePath((sqSize - strokeWidth) / 2).circumference} ${calculatePath((sqSize - strokeWidth) / 2).circumference}`}
        strokeDashoffset={calculatePath((sqSize - strokeWidth) / 2).offset}
      />
      </g>
      <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize="16px" fontWeight="bold"fill={color}>
        {progress}%
      </text>
    </svg>
  );
};

export default CircleProgressBar;